import React, { useEffect, useState } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

import * as R from 'ramda';

import Container from '@components/Container';
import Loading from '@components/Base/Loading';

import { unLockScroll } from '@utils/ui';
import { fetch } from '@utils/fetch';

const useStyles = createUseStyles(({
  fontColor,
  rem,
}) => ({
  '@global': {
    button: {
      outline: 'transparent',
      margin: rem(6),
    },
  },
  root: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    color: '#FFF',
    display: 'flex',
    zIndex: 999,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  content: {
    height: '100%',
    marginTop: rem(10),
    overflow: 'auto',
    '& > img': {
      width: rem(210),
      height: rem(300),
      objectFit: 'cover',
      marginBottom: rem(20),
    }
  },
  title: {
    color: '#000',
    width: '100%',
    fontSize: rem(16),
    fontWeight: 'normal',
    lineHeight: '20px',
    marginTop: 50,
    '& > span': {
      width: '80%',
      textAlign: 'center',
      marginLeft: rem(30),
    }
  },
  close: {
    border: 'unset',
    color: fontColor.primary,
    cursor: 'pointer',
    padding: 0,
    outline: 'transparent',
    backgroundColor: 'transparent',
  },
  loading: {
    color: '#000',
    margin: [rem(200), 0],
  },
}), {
    name: 'CertificateModal'
});

// 溯源信息中证书弹窗
const TrancCertModal = props => {
  const {
    t,
    data,
    language,
    setOpenTrancCert,
  } = props;
  const theme = useTheme();
  const classes = useStyles(theme);

  const [loading, setLoading] = useState(true);
  const [curr, setCurr] = useState(null);

  const belong = R.pathOr('dcp1', ['belong'])(data);
  const index = R.pathOr('0', ['index'])(data);

  useEffect(() => {
    setLoading(true);
    const params = {
      types: [belong],
      language,
    };
    fetch(params).then(data => {
      const dcpData = R.pathOr({}, ['jsonData', belong, index])(data);
      const certlist = R.pathOr([], ['custom', 'certlist'])(dcpData);
      setCurr(certlist);
      setLoading(false);
    }, err => {
      console.log(err, '获取图片信息失败，请重新打开');
    });
  }, [language, belong, index]);

  const handleClose = () => {
    setOpenTrancCert(false);
    unLockScroll();
  }

  const createMain = () => {
    return (
      <>
        <Container
          flex
          alignItems='center'
          className={classNames(classes.title)}
        >
          <span>{t('certificate')}</span>
          <button 
            onClick={handleClose}
            className={classNames(classes.close)} 
          >
            <Icon path={mdiClose} size='24px' />
          </button>
        </Container>

        <Container 
          flex
          direction='column'
          justify='center'
          alignItems='center'
          className={classNames(classes.content)}
        >
          {
            (curr && curr.length > 0) && (
              curr.map((item, index) => (
                <img
                  key={String(index)}
                  src={R.pathOr('', ['filelocation'])(item)}
                  alt='Certificate'
                />
              ))
            )
          }
        </Container>
      </>
    )
  }

  return (
    <Container
      flex
      direction='column'
      items='space-between'
      className={classNames(classes.root)}
    >
      {
        loading ? (<Loading size={1} className={classes.loading} />) : createMain()
      }
    </Container>
  )
};

TrancCertModal.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  setOpenTrancCert: PropTypes.func.isRequired,
}

export default TrancCertModal;
